import { Button, message } from '@nackle/paper';
import { Warning, FloppyDisk } from '@nackle/icons';
import React, { Component, ReactNode } from 'react';
import { getBundle } from 'app/dux/cmx/actions';

interface SaveButtonProps {
    readonly disabled?: boolean;
    readonly className?: string;
    readonly id?: string;
    readonly children?: ReactNode;
    readonly save: () => Promise<any>;
    readonly getBundle: typeof getBundle;
    readonly successMessage?: string;
    readonly errorMessage?: string;
}

export default class SaveButton extends Component<SaveButtonProps> {
    static defaultProps: Partial<SaveButtonProps> = {
        disabled: false,
        className: 'save-button',
        id: 'saveButton',
        children: 'Save',
        successMessage: 'Saved successfully',
        errorMessage: 'There was an error while saving',
    };

    state = {
        saving: false
    };

    save = async () => {
        this.setState({ saving: true });

        try {
            await this.props.save();

            // this.props.getBundle('en-US');

            message.success({
                icon: <FloppyDisk/>,
                content: this.props.successMessage,
            });
        } catch (e) {
            message.error({
                icon: <Warning/>,
                content: this.props.errorMessage,
            });
            console.error(e);
        } finally {
            this.setState({ saving: false });
        }
    };

    render() {
        const {
            className,
            id,
            disabled
        } = this.props;
        const saving = this.state.saving;
        return (
            <Button
                disabled={disabled}
                icon={<FloppyDisk/>}
                type="primary"
                loading={saving}
                className={`${className ? className : ''}`}
                id={id}
                onClick={this.save}
                style={{display: 'flex'}}
            >
                {this.props.children}
            </Button>
        );
    }
}
